/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import { Button, Typography } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Azure
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./config";

import { useAuthContext } from "context/AuthContext";
import { useNavigate } from "react-router-dom";

const defaultObj = {
  email: "",
  password: "",
};

function Login() {
  const [account, setAccount] = useState(defaultObj);
  const [encoded, setEncoded] = useState('');
  const [step, setStep] = useState(0);
  const [credentialAzure, setCredentialAzure] = useState();

  const navigate = useNavigate();

  const { login } = useAuthContext();

  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  useEffect(() => {
    (async () => {
      setEncoded(Buffer.from(`${account.email}:${account.password}:${null}`).toString("base64"));

      if (isAuthenticated) await login(Buffer.from(credentialAzure).toString("base64"), 'azure');
    })()

    // eslint-disable-next-line
  }, [credentialAzure, isAuthenticated, account])

  const handleChange = (event) => {
    const { name, value } = event.target;

    setAccount((account) => {
      return {
        ...account,
        [name]: value,
      };
    });
  }

  return (
    <>
      <BasicLayout image={bgImage}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="success"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Login
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              {step === 0 ?
                (
                  <>
                    <MDBox mb={6}>
                      <Button
                        onClick={() => setStep(1)}
                        variant="outlined"
                        sx={{ padding: 3, ":hover": { borderColor: '#3f50b5' } }}
                        fullWidth
                      >
                        <Typography color="#3f50b5" variant="p" fontSize={13}>Acesso RH</Typography>
                      </Button>
                    </MDBox>
                    <MDBox mb={6}>
                      <Button
                        variant="outlined"
                        sx={{ padding: 3, ":hover": { borderColor: '#3f50b5' } }}
                        fullWidth
                        onClick={async () => {
                          const credentialAzure = await instance.loginPopup(loginRequest).catch(() => {
                            sessionStorage.clear();
                            toast.info("Não foi possível fazer login");
                          });

                          // console.log({
                          //   credentialAzure,
                          //   accessToken: credentialAzure?.accessToken,
                          //   preferred_username: credentialAzure?.idTokenClaims?.preferred_username,
                          //   credentialAzureTty: `${credentialAzure?.idTokenClaims?.preferred_username}:${credentialAzure?.uniqueId}`
                          // });

                          setCredentialAzure(`${credentialAzure?.account?.username}:${credentialAzure?.uniqueId}:${credentialAzure?.accessToken}`);
                        }}
                      >
                        <Typography color="#3f50b5" variant="p" fontSize={13}>Acesso Cooperativa</Typography>
                      </Button>
                    </MDBox>
                  </>
                ) : (
                  <>
                    <Typography color='#3f50b5' fontSize={12} display='flex' alignItems='center' marginBottom={5} sx={{ cursor: 'pointer' }} onClick={() => setStep(0)}>
                      <ArrowBackIcon /> Tipos de acesso
                    </Typography>

                    <MDBox mb={2}>
                      <MDInput
                        type="email"
                        label="Email"
                        name="email"
                        value={account.email}
                        onChange={handleChange}
                        fullWidth
                      />
                    </MDBox>
                    <MDBox mb={2}>
                      <MDInput
                        type="password"
                        label="Password"
                        name="password"
                        value={account.password}
                        onChange={handleChange}
                        fullWidth
                      />
                    </MDBox>
                    <MDBox mt={4} mb={1}>
                      <MDButton
                        variant="gradient"
                        color="light"
                        onClick={() => login(encoded, 'company')}
                        fullWidth
                      >
                        Login
                      </MDButton>
                    </MDBox>
                    <MDBox mt={3} mb={1} textAlign="center">
                      <MDTypography variant="button" color="text" onClick={() => navigate('/auth/password')}>
                        <MDTypography
                          variant="button"
                          color="info"
                          fontWeight="medium"
                          textGradient
                          style={{ cursor: "pointer" }}
                        >
                          Esqueceu a Senha?
                        </MDTypography>
                      </MDTypography>
                    </MDBox>
                  </>
                )}
            </MDBox>
          </MDBox>
        </Card>
      </BasicLayout>
      <ToastContainer />
    </>
  )
}

export default Login;
